import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { contentViewerSelectors } from '@tabeeb/modules/contentViewer'
import { getIsContentReadonly } from '@tabeeb/modules/readonlyWhiteboard/selectors'

import Polygon from '../components/Polygon'

import * as annotationActions from '../actions'
import * as annotationsSelectors from '../selectors'
import { convertAnnotationObjectToComponent } from '../services/annotationsService'

import AnnotationContainer from './AnnotationContainer'

class PolygonContainer extends AnnotationContainer {
  constructor(props) {
    super(props)

    this.selectionProps = {
      onClick: this._handleSelect,
    }

    this.hoverProps = {
      onMouseEnter: this._handleMouseEnter,
      onMouseLeave: this._handleMouseLeave,
    }

    this.contextMenuProps = {
      onContextMenu: this._handleContextMenu,
    }

    this.dragAndDropProps = {
      draggable: !props.isReadonlyView,
      onDragStart: this._handleDragStart,
      onDragEnd: this._handleDragEnd,
    }
  }

  _handleDragEnd = (e) => {
    const { target } = e
    const { annotation } = this.state

    const offsetX = target.x() - Polygon.getXY(annotation).x
    const offsetY = target.y() - Polygon.getXY(annotation).y

    const updatedCoordinates = annotation.Coordinates.map((coords) => ({
      Start: { X: coords.Start.X + offsetX, Y: coords.Start.Y + offsetY },
      End: { X: coords.End.X + offsetX, Y: coords.End.Y + offsetY },
    }))

    const newAnnotation = {
      ...annotation,
      Coordinates: updatedCoordinates,
    }

    this.setState({ annotation: newAnnotation })
    this._handleEndUpdate(e)
  }

  render() {
    const { hovered, selected, annotation } = this.state
    const { childAnnotation, contentScale, opacity } = this.props

    const props = {
      annotation,
      annotationRef: this.annotationRef,
      opacity,
      hovered,
      contentScale,
      selected,
      hoverProps: this.hoverProps,
      selectionProps: this.selectionProps,
      contextMenuProps: this.contextMenuProps,
      dragAndDropProps: this.dragAndDropProps,
    }

    return (
      <Polygon {...props}>
        {convertAnnotationObjectToComponent(childAnnotation, {
          parentHovered: props.hovered,
          parentSelected: props.selected,
        })}
      </Polygon>
    )
  }
}

PolygonContainer.propTypes = {
  childAnnotation: PropTypes.object,
  currentAnnotation: PropTypes.object.isRequired,
}

const mapStateToProps = (state, { Id }) => {
  return {
    currentAnnotation: annotationsSelectors.getAnnotationById(state, { Id }),
    childAnnotation: annotationsSelectors.getAnnotationChild(state, { Id }),
    opacity: annotationsSelectors.getAnnotationOpacity(state, { Id }),
    contentScale: contentViewerSelectors.getContentScale(state),
    selected: annotationsSelectors.getIsAnnotationSelected(state, { Id }),
    isReadonlyView: getIsContentReadonly(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    annotationActions: bindActionCreators(annotationActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolygonContainer)
